import _ from 'underscore';
import {
    GET_ALL_TRACKER_USERS_WITH_PROFILE,
    GET_ALL_USERS_WITH_PROFILE,
    SET_VERIFIED_TO_USER,
    SET_IS_ACTIVE_TO_USER,
    ADD_NOTE_TO_USER,
    REMOVE_NOTE_FROM_USER,
} from './types';
import {
    getAllTrackerUsersWithProfileFromFirebase,
    getAllUsersWithProfileFromFirebase,
    setVerifiedToUserToFirebase,
    setIsActiveToUserToFirebase,
    addNoteToUserToFirebase,
    removeNoteFromUserFromFirebase,
} from '../helpers/firebase';

export async function getAllTrackerUsersWithProfile() {
    const users = await getAllTrackerUsersWithProfileFromFirebase();

    return {
        type: GET_ALL_TRACKER_USERS_WITH_PROFILE,
        payload: users,
    };
}

export async function getAllUsersWithProfile() {
    const users = await getAllUsersWithProfileFromFirebase();

    return {
        type: GET_ALL_USERS_WITH_PROFILE,
        payload: users,
    };
}

export function setVerifiedToUser(user, verified) {
    setVerifiedToUserToFirebase(user, verified);

    return {
        type: SET_VERIFIED_TO_USER,
        payload: {ownerKey: user.key, verified},
    };
}

export function setIsActiveToUser(user, isActive) {
    setIsActiveToUserToFirebase(user, isActive);

    return {
        type: SET_IS_ACTIVE_TO_USER,
        payload: {ownerKey: user.key, isActive},
    };
}

export async function addNoteToUser(user, note) {
    const newNote = await addNoteToUserToFirebase(user, note);

    return {
        type: ADD_NOTE_TO_USER,
        payload: _.extend(newNote, {ownerKey: user.key}),
    };
}

export async function removeNoteFromUser(user, note) {
    removeNoteFromUserFromFirebase(user, note);

    return {
        type: REMOVE_NOTE_FROM_USER,
        payload: note.key,
    };
}


// WEBPACK FOOTER //
// ./src/app/actions/users_actions.js